export default "__VITE_ASSET__a3ea40b0__"